import { ListTonesViewModelImpl } from './viewmodel/listtoneviewmodel';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentHandler, UIDataModel, UIComponentState } from '../../../toolkit/uicomponent';
import { ListTonesComponentProps, ListTonesComponentHandler, ListTonesComponentState } from './listtonecomponent';
import { ListToneCSSStyle } from './listtonecss';
import * as React from 'react';
// import { HorizontalListComponent, ArrowsPaddingType, ArrowsSizeType, GutterType, MarginTopType, ArrowsType } from '../../../toolkit/horizontallist/horizontallistcomponent';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { Strings } from '../../../../utils/resources/strings';
import { AlertComponent } from '../../../toolkit/alert/alertcomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { CarouselComponent, CarouselType } from '../../../toolkit/carousel/carouselcomponent';
import { LoaderWrapperComponent } from '../../popup/loaderwrappercomponent';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
import './list-tone-style.css';
import { DeleteInfoComponent } from '../../popup/info/deleteinfo/deleteinfocomponent';
import { SwitchComponent } from '../../../toolkit/switch/switchcomponent';
import { SwitchCSSStyleImpl } from '../../../toolkit/switch/switchcss';

export class ListToneViewImpl extends UIComponentViewImpl<UIDataModel> {
    switchComponent: SwitchComponent;

    private popUpComponent: PopUpWrapperComponent;
    private loaderWrapperComponent: LoaderWrapperComponent;
    constructor(private listTonesViewModel: ListTonesViewModelImpl,
        applicationContext: BaseContext, uiComponentHandler: UIComponentHandler) {
        super(applicationContext, uiComponentHandler);
    }

    // bindHandlers()
    // {
    //     this.loadMore = this.loadMore.bind(this);
    bindHandlers() {
        this.showPopup = this.showPopup.bind(this);
        this.showShuffleSuccessActivatePopup = this.showShuffleSuccessActivatePopup.bind(this);
        this.showShuffleSuccessDeActivatePopup = this.showShuffleSuccessDeActivatePopup.bind(this);
        this.showShuffleFailurePopup = this.showShuffleFailurePopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.closeShufflePopup = this.closeShufflePopup.bind(this);
        this.infoClick = this.infoClick.bind(this);
        this.onDeleteSuccess = this.onDeleteSuccess.bind(this);
        this.isShuffleOn = this.isShuffleOn.bind(this);
        this.callShuffleActivateAPI = this.callShuffleActivateAPI.bind(this);
        this.callShuffleDeactivateAPI = this.callShuffleDeactivateAPI.bind(this);

        // this.onShuffle = this.onShuffle.bind(this);
    }

    draw(props: ListTonesComponentProps, state: ListTonesComponentState, cssStyle: ListToneCSSStyle): JSX.Element | boolean {
        super.draw(props, state, cssStyle);

        this.listTonesViewModel.setTitleCSSStyle(cssStyle.getTitleCSSStyle());

        return (
            <>
                <div id="listtone-web">
                    {
                        this.getWebView(props, state, cssStyle)
                    }
                </div>
                {/* <div id="listtone-mobile">
                       {
                           this.getMobileView(props, state, cssStyle)
                       }

                   </div>
                         */}
                <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context} />
                <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context} />
            </>

        );

    }

    getWebView(props: ListTonesComponentProps, state: ListTonesComponentState, cssStyle: ListToneCSSStyle) {
        return (
            <>

                {this.listTonesViewModel.getListOfDatas().length > 0 &&
                    <div id="list-tone-mainwrapper" style={{}}>
                        <div id="list-tone-title-label" style={cssStyle.getTitleCSSStyle()}>

                            {props.context.getResources().getString(Strings.currently_playing_tunes_in_list)}
                            <div id="listtone-toggle-div" style={{}}>
                                <label id="listtone-toggle-label" style={{}}>
                                    {this.getContext().getResources().getString(Strings.shuffle)}
                                </label>
                                <SwitchComponent ref={(item: any) => this.switchComponent = item} onChange={this.isShuffleOn} style={new SwitchCSSStyleImpl(this.getContext())} isChecked={state.shuffleStatus} context={this.getContext()} />
                            </div>


                        </div>
                        <div id="carousel-web">
                            {
                                this.getCarouselWeb(props, state, cssStyle)
                            }
                        </div>
                        <div id="carousel-mobile">
                            {
                                this.getCarouselMobile(props, state, cssStyle)
                            }
                        </div>

                    </div>
                }
            </>
        );
    }

    getCarouselMobile(props: ListTonesComponentProps, state: UIComponentState, cssStyle: ListToneCSSStyle): JSX.Element {
        return (
            <>
                <div style={{ width: '100%', marginTop: '0px', textAlign: 'left', display: 'flex', marginBottom: "30px", marginLeft: "15px", height: '10px', lineHeight: '10px', fontSize: '7px' }}>
                    <label style={{ width: 'auto', fontFamily: this.getContext().getResources().getFontFamily(), height: '100%', color: '#898989', fontWeight: 900 }}>
                        {this.getContext().getResources().getString(Strings.want_to_edit_your_playing_list)}
                    </label>
                    <label onClick={this.infoClick} style={{ width: '100px', cursor: "pointer", fontFamily: this.getContext().getResources().getFontFamily(), marginLeft: '6px', fontWeight: 900, height: "100%", color: '#003187' }}>
                        {this.getContext().getResources().getString(Strings.learn_more)}
                    </label>
                </div>
                <div style={{ width: "100%", height: "570px" }}>
                    <CarouselComponent slidePerviewMobile={1} isIndicatorRequired={false} slidePerview={4} id="listtone" carouselType={CarouselType.BANNER} listViewModel={this.listTonesViewModel} context={this.getUIProps().context} />
                </div>

            </>
        );
    }
    getCarouselWeb(props: ListTonesComponentProps, state: UIComponentState, cssStyle: ListToneCSSStyle): JSX.Element {
        return (
            <>
                <div id="learn-more-wrapper" style={{ width: '100%', paddingRight: "5%", paddingLeft: "0%", marginBottom: "40px", marginTop: '20px', textAlign: 'left', display: 'flex', height: '19px', lineHeight: '19px', fontSize: '14px' }}>
                    <label style={{ width: 'auto', fontFamily: this.getContext().getResources().getFontFamily(), height: '100%', color: '#898989', fontWeight: 900 }}>
                        {this.getContext().getResources().getString(Strings.want_to_edit_your_playing_list)}
                    </label>
                    <label id="learn-more-label" onClick={this.infoClick} style={{ width: '100px', cursor: "pointer", fontFamily: this.getContext().getResources().getFontFamily(), marginLeft: '6px', fontWeight: 900, height: "100%", color: '#003187' }}>
                        {this.getContext().getResources().getString(Strings.learn_more)}
                    </label>
                </div>
                <div style={{ width: "100%", height: "550px" }}>
                    <CarouselComponent slidePerviewMobile={2} isIndicatorRequired={false} slidePerview={4} id="listtone" carouselType={CarouselType.BANNER} listViewModel={this.listTonesViewModel} context={this.getUIProps().context} />
                </div>
            </>
        );
    }
    isShuffleOn(isShuffleOn: boolean): void {
        console.log("-----tiger", isShuffleOn);
        // return this.switchComponent !== null && this.switchComponent.isChecked();
        (this.getUIComponentHandler() as ListTonesComponentHandler).isShuffleOn(isShuffleOn);

    }
    updateShuffleButton(): void {

        this.switchComponent.updateShuffle();
    }
    getMobileView(props: ListTonesComponentProps, state: UIComponentState, cssStyle: ListToneCSSStyle) {
        return (
            <>
                {this.listTonesViewModel.getListOfDatas().length > 0 &&
                    <div >
                        <div style={cssStyle.getMobileTitleCSSStyle()}>{props.context.getResources().getString(Strings.currently_playing_tunes_in_list)}</div>
                        <div style={{ width: '100%', marginTop: '0px', textAlign: 'left', display: 'flex', marginBottom: "30px", marginLeft: "30px", height: '10px', lineHeight: '10px', fontSize: '7px' }}>
                            <label style={{ width: 'auto', fontFamily: this.getContext().getResources().getFontFamily(), height: '100%', color: '#898989', fontWeight: 900 }}>
                                {this.getContext().getResources().getString(Strings.want_to_edit_your_playing_list)}
                            </label>
                            <label onClick={this.infoClick} style={{ width: '100px', cursor: "pointer", fontFamily: this.getContext().getResources().getFontFamily(), marginLeft: '6px', fontWeight: 900, height: "100%", color: '#003187' }}>
                                {this.getContext().getResources().getString(Strings.learn_more)}
                            </label>
                        </div>
                        <div style={{ width: "100%", height: "550px" }}>
                            <CarouselComponent slidePerviewMobile={2} isIndicatorRequired={false} slidePerview={4} id="listtone" carouselType={CarouselType.BANNER} listViewModel={this.listTonesViewModel} context={this.getUIProps().context} />
                        </div>
                    </div>
                }
            </>
        );
    }

    infoClick(): void {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
            <DeleteInfoComponent headerTitle={this.getContext().getResources().getString(Strings.info)} onOkClick={this.closePopup} closePopup={this.closePopup} context={this.getContext()} />);
    }
    showShuffleSuccessActivatePopup() {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getUIProps().context.getResources().getString(Strings.confirm)} alertMessage={this.getUIProps().context.getResources().getString(Strings.shuffle_activate)} alertType={AlertType.AUTHENTICATE} onCloseButtonClick={this.closeShufflePopup} onClick={this.callShuffleActivateAPI} context={this.getUIProps().context} />);
    }
    showShuffleSuccessDeActivatePopup() {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getUIProps().context.getResources().getString(Strings.confirm)} alertMessage={this.getUIProps().context.getResources().getString(Strings.shuffle_deactivate)} alertType={AlertType.AUTHENTICATE} onCloseButtonClick={this.closeShufflePopup} onClick={this.callShuffleDeactivateAPI} context={this.getUIProps().context} />);
    }
    showLoader() {

        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true, <LoaderComponent context={this.getUIProps().context} />);
    }

    dismissLoader() {
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    //  onShuffle(): void
    // {
    //     (this.getUIComponentHandler() as ListTonesComponentHandler).isShuffleOn(this.isShuffleOn());
    // }

    showPopup(id: string, msg: string, type: AlertType): void {
        this.closePopup();
        if (type === AlertType.SUCCESS) {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={() => ""} context={this.getUIProps().context} />);
        }

        else {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context} />);
        }
    }
    showShuffleFailurePopup(id: string, msg: string, type: AlertType): void {


        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closeShufflePopup} onClick={this.closeShufflePopup} context={this.getUIProps().context} />);

    }
    callShuffleActivateAPI() {
        (this.getUIComponentHandler() as ListTonesComponentHandler).showShuffleActivatePopup();
    }
    callShuffleDeactivateAPI() {
        (this.getUIComponentHandler() as ListTonesComponentHandler).showShuffleDeActivatePopup();
    }
    closePopup() {

        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }
    protected closeShufflePopup() {
        this.updateShuffleButton();
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }
    // private loadMore(startIndex: number, offset: number)
    // {
    //     let props = (this.getUIProps() as FeaturedCategoryListComponentProps);

    //      props.onLoadMore(props.featuredCategory, startIndex, offset);
    // }

    protected onDeleteSuccess(id: string, type: string): void {
        this.closePopup();
        console.log("list tone view delete ---", this.listTonesViewModel.deleteData(id));
        this.listTonesViewModel.deleteData(id);
        this.getUIComponentHandler().forceUpdateComponent();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/listtone/listtoneview.tsx